"use strict";

var _classCallCheck = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var file_1 = require("./file");

var BrandPictureDTO =
/*#__PURE__*/
function (_file_1$FileDTO) {
  _inherits(BrandPictureDTO, _file_1$FileDTO);

  function BrandPictureDTO() {
    _classCallCheck(this, BrandPictureDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(BrandPictureDTO).apply(this, arguments));
  }

  return BrandPictureDTO;
}(file_1.FileDTO);

exports.BrandPictureDTO = BrandPictureDTO;

var BrandPictureCreationDTO =
/*#__PURE__*/
function (_file_1$FileCreationD) {
  _inherits(BrandPictureCreationDTO, _file_1$FileCreationD);

  function BrandPictureCreationDTO() {
    _classCallCheck(this, BrandPictureCreationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(BrandPictureCreationDTO).apply(this, arguments));
  }

  return BrandPictureCreationDTO;
}(file_1.FileCreationDTO);

exports.BrandPictureCreationDTO = BrandPictureCreationDTO;

var BrandPictureUpdateDTO =
/*#__PURE__*/
function (_file_1$FileUpdateDTO) {
  _inherits(BrandPictureUpdateDTO, _file_1$FileUpdateDTO);

  function BrandPictureUpdateDTO() {
    _classCallCheck(this, BrandPictureUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(BrandPictureUpdateDTO).apply(this, arguments));
  }

  return BrandPictureUpdateDTO;
}(file_1.FileUpdateDTO);

exports.BrandPictureUpdateDTO = BrandPictureUpdateDTO;